import { render, staticRenderFns } from "./ProductFavorite.vue?vue&type=template&id=2eda9f64&scoped=true&"
import script from "./ProductFavorite.vue?vue&type=script&lang=js&"
export * from "./ProductFavorite.vue?vue&type=script&lang=js&"
import style0 from "./ProductFavorite.vue?vue&type=style&index=0&id=2eda9f64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eda9f64",
  null
  
)

export default component.exports